import styled from 'styled-components'
import { palette } from '../styles/branding'

export const HeaderContainer = styled.header`
  align-items: center;
  background-color: ${(props) => (props.light ? palette.neutral4 : '#4e4e4e')};
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 12px 24px;
  width: 100%;
`
export const TimeWrapper = styled.div`
  align-items: center;
  width: 115px;
`
export const Title = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  margin: 0 8px;
  min-width: 0;
  & h1 {
    color: ${(props) => (props.light ? palette.dark : palette.neutral4)};
    flex: 1;
    font-family: 'Flanders Art Sans', sans-serif;
    font-size: clamp(1.5rem, 2.4rem, 3.375rem);
    font-weight: bold;
    margin: 0;
    max-width: calc(100%);
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
export const DepartureWrapper = styled.p`
  color: ${(props) => (props.light ? palette.dark : palette.neutral4)};
  font-family: 'Flanders Art Sans', sans-serif;
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  text-align: right;
  visibility: hidden;
  width: 115px;
  @media (max-width: 600px) {
    font-size: 16px;
  }
`
